import { Link, useLocation } from 'react-router-dom';

export default function MenuItemMobile({ title, icon, href, clickable, open, setOpen, realState }) {
  const location = useLocation();

  return (
    <>
      {clickable ? (
        <button
          onClick={() => setOpen(!open)}
          className={`
            ${
              open ? 'text-primary font-bold' : 'text-text-normal'
            } flex flex-col gap-1 items-center justify-center disabled:opacity-50`}
        >
          {icon}
          <p className="text-xs">{title}</p>
        </button>
      ) : realState ? (
        <Link
          to={href}
          onClick={() => {
            setOpen(false);
          }}
          className={`${
            location.pathname === href && !open ? 'text-primary font-bold' : 'text-text-normal'
          } flex flex-col gap-1 items-center justify-center`}
        >
          {icon}
          <p className="text-xs">{title}</p>
        </Link>
      ) : href != '/requests' ? (
        <button
          disabled={true}
          onClick={() => {
            setOpen(false);
          }}
          className={`${
            location.pathname === href && !open ? 'text-primary font-bold' : 'text-text-normal'
          } flex flex-col gap-1 items-center justify-center disabled:opacity-50`}
        >
          {icon}
          <p className="text-xs">{title}</p>
        </button>
      ) : (
        <Link
          to={href}
          onClick={() => {
            setOpen(false);
          }}
          className={`${
            location.pathname === href && !open ? 'text-primary font-bold' : 'text-text-normal'
          } flex flex-col gap-1 items-center justify-center`}
        >
          {icon}
          <p className="text-xs">{title}</p>
        </Link>
      )}
    </>
  );
}
